import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '../../../../../styles';
import Slider from 'material-ui/Slider';
import styles from './styles';

import { defaultMapStateToProps, defaultMapDispatchToProps } from '../redux';

function mapStateToProps(state, ownProps) {
    return {
        ...defaultMapStateToProps(state, ownProps),
        value: state.crud.entityCrud.get(ownProps.field.id),
    };
}

const propTypes = {
    styles: PropTypes.string.isRequired,
    field: PropTypes.object.isRequired,
    error: PropTypes.string,
    mandatory: PropTypes.bool,
    description: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    onRemove: PropTypes.func,
};

@connect(mapStateToProps, defaultMapDispatchToProps)
@withStyles(styles)
class CrudPercentField extends Component {
    state = { value: 0 };

    onChange = (_, value) => {
        let { onChange, onRemove, field } = this.props;
        if (value) {
            onChange && onChange(field.id, value);
        } else {
            onRemove && onRemove(field.id);
        }
        this.setState({ value: value });
    };

    render() {
        let { styles, field, hidden, readOnly, mandatory, description, error } = this.props;
        let { value } = this.state;
        return hidden ? (
            <div style={{ ...styles.content, ...styles.fieldContainer }}>
                <span style={styles.title}>
                    {description} {mandatory ? '*' : ''}
                </span>
                <span className="slide-crud-field">
                    <Slider
                        errorText={error}
                        disable={readOnly}
                        style={styles.sliderStyle}
                        sliderStyle={styles.sliderStyle2}
                        defaultValue={value}
                        step={0.1}
                        onChange={this.onChange}
                    />
                </span>
                <span style={styles.textPercent}>{value * 100}%</span>
            </div>
        ) : null;
    }
}

CrudPercentField.propTypes = propTypes;

export default CrudPercentField;
